var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoSearchBlackBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4304 7.9651C13.4304 10.9835 10.9835 13.4304 7.96508 13.4304C4.94669 13.4304 2.49979 10.9835 2.49979 7.9651C2.49979 4.9467 4.94669 2.4998 7.96508 2.4998C10.9835 2.4998 13.4304 4.9467 13.4304 7.9651ZM12.6441 14.4117C11.3304 15.3668 9.71354 15.9302 7.96508 15.9302C3.56609 15.9302 0 12.3641 0 7.9651C0 3.5661 3.56609 0 7.96508 0C12.3641 0 15.9302 3.5661 15.9302 7.9651C15.9302 9.71354 15.3668 11.3304 14.4117 12.6441L19.2929 17.5253C19.6834 17.9158 19.6834 18.549 19.2929 18.9395L18.9395 19.2929C18.549 19.6834 17.9158 19.6834 17.5253 19.2929L12.6441 14.4117Z",
    fill: "#382E51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSearchBlackBold);
export default __webpack_public_path__ + "static/media/ico_search_black_bold.e57d2bd8956d026470254cb50868eee3.svg";
export { ForwardRef as ReactComponent };